import cloneDeep from 'lodash/cloneDeep'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const initialState = {
  loading: false,
  incompleteCampaignList: [],
  incompleteCampaignCount: 0,
}

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  getters,
  actions,
  mutations,
}
